import apiService from './api';

export interface SpCommissionReportRow {
  statementId: string;
  category: string;
  periodYear: number;
  periodQuarter?: number;
  periodMonth?: number;
  totalAmount: number;
  deliveryStatus: string;
  generatedUtc: string;
  sentUtc?: string;
}

const spCommissionReportService = {
  async list(params?: {
    year?: number;
    quarter?: number;
    month?: number;
    category?: string;
  }): Promise<SpCommissionReportRow[]> {
    const qs = new URLSearchParams();
    if (params?.year) qs.set('year', String(params.year));
    if (params?.quarter) qs.set('quarter', String(params.quarter));
    if (params?.month) qs.set('month', String(params.month));
    if (params?.category) qs.set('category', params.category);
    const q = qs.toString();
    return apiService.get<SpCommissionReportRow[]>(
      `/api/account/sp-commission-reports${q ? `?${q}` : ''}`
    );
  },

  async getCsvText(statementId: string): Promise<string> {
    const base = apiService.getBaseUrl?.() || window.location.origin;
    const token = apiService.getAccessToken?.() || localStorage.getItem('accessToken');
    const res = await fetch(
      `${base}/api/account/sp-commission-reports/${statementId}/csv/text`,
      { headers: token ? { Authorization: `Bearer ${token}` } : {} }
    );
    if (!res.ok) throw new Error(`CSV preview failed (${res.status})`);
    return res.text();
  },

  async downloadCsv(statementId: string, filename: string): Promise<void> {
    const base = apiService.getBaseUrl?.() || window.location.origin;
    const token = apiService.getAccessToken?.() || localStorage.getItem('accessToken');
    const res = await fetch(
      `${base}/api/account/sp-commission-reports/${statementId}/csv`,
      { headers: token ? { Authorization: `Bearer ${token}` } : {} }
    );
    if (!res.ok) throw new Error(`CSV download failed (${res.status})`);
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  },
};

export default spCommissionReportService;
